import { Button } from "@design-system/Button/Button";
import "@components/transactions/TransactionsBulkActions/TransactionsUpdateStatus/TransactionsUpdateToast.scss";

interface ScheduleReviewUndoToastProps {
    message: string;
    detail?: string;
    onUndo?: () => void;
}

export const ScheduleReviewUndoToast = ({
    message,
    detail,
    onUndo,
}: ScheduleReviewUndoToastProps) => (
    <div className="transactions-update-toast">
        <div className="transactions-update-toast__content">
            <p className="transactions-update-toast__label">{message}</p>
            {detail && (
                <p className="transactions-update-toast__info">{detail}</p>
            )}
        </div>
        {onUndo && (
            <div className="transactions-update-toast__actions">
                <Button variant="primary" size="lg" onClick={onUndo}>
                    Undo
                </Button>
            </div>
        )}
    </div>
);
